"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadFunctionRenderer = loadFunctionRenderer;
const commonjs_loader_1 = require("../module/commonjs_loader");
/**
 * Loads the renderer for a function template type.
 *
 * Basically just loads the included js module.
 */
/* eslint @typescript-eslint/no-explicit-any:0 */
function loadFunctionRenderer(moduleJs, dependencies) {
    const require = (name) => {
        const module = dependencies[name];
        if (module === undefined)
            throw new Error(`Can't find module ${name}. Missing in dependencies?`);
        return module;
    };
    return (0, commonjs_loader_1.loadModule)(moduleJs, require);
}
//# sourceMappingURL=function_renderer.js.map